import type { Recipient } from '@/types/mail';
import type { UnseenEventsResponse } from '@/types/user';

const EVALUATION_REPORT_PATH = '/Family/ReportPupilMarks/Get';
const FINAL_EVALUATION_REPORT_PATH = '/Family/PupilMarksFinal';
const INDIVIDUAL_SUPPORT_PLAN_PATH = 'app-link/individual-support-plans';
const PRESCHOOL_EVALUATION_PATH = '/preschool-evaluation-submissions';
const HOME_TASK_ANSWER_CLASS = 'open-mail-ht-answer';
const ATTACHMENT_PATH = '/Attachment/Get/';

export const getRecipientKey = (recipient: Recipient): string =>
  `${recipient.groupId}-${recipient.id}`;

export const getMailTabCount = (events?: UnseenEventsResponse): number =>
  (events?.mailMessageCount ?? 0) +
  (events?.surveyCount ?? 0) +
  (events?.videoMeetingCount ?? 0);

export const hasEvaluationReportPath = (href: string): boolean =>
  href.includes(EVALUATION_REPORT_PATH);

export const getFinalEvaluationReportParameters = (
  href: string,
): string | null => {
  if (!href.includes(FINAL_EVALUATION_REPORT_PATH)) {
    return null;
  }

  const { searchParams } = new URL(href, window.location.origin);

  return searchParams.get('parameters');
};

export const hasIndividualSupportPlanPath = (href: string): boolean =>
  href.includes(INDIVIDUAL_SUPPORT_PLAN_PATH);

export const hasPreschoolEvaluationPath = (href: string): boolean =>
  href.includes(PRESCHOOL_EVALUATION_PATH);

export const getAttachmentLinkId = (href: string): string | null => {
  if (!href.startsWith(ATTACHMENT_PATH)) {
    return null;
  }

  return href.slice(ATTACHMENT_PATH.length) || null;
};

export const getHomeTaskId = (anchor: HTMLAnchorElement): number | null => {
  if (!anchor.classList.contains(HOME_TASK_ANSWER_CLASS)) {
    return null;
  }

  const homeTaskId = Number(anchor.dataset.htid);

  return homeTaskId || null;
};
